import React from "react";

const HotelScoreRange = ({ score }) => {
  const classes = `level ${score.levelClass}`;
  const style = {
    width: `${(parseInt(score.value, 10) * 10).toString()}%`,
  };

  return (
    <span
      itemProp="aggregateRating"
      itemScope
      itemType="https://schema.org/AggregateRating"
    >
      <span className="range">
        <span className={classes} style={style} />
      </span>{" "}
      <span className="score">{score.formatted} / 10</span>
      <meta itemProp="ratingValue" content={score.value} />
      <meta itemProp="bestRating" content="10" />
      <meta itemProp="reviewCount" content={score.reviewsCount} />
    </span>
  );
};

export default HotelScoreRange;
